import { object } from 'prop-types'
import React from 'react'
import { StyledLabel, StyledValue, StyledWrapperBox } from './styles/style'

const SimpleApiFieldText = ({ data }) => {
	return (
		<StyledWrapperBox>
			<StyledLabel>{data.field.label}</StyledLabel>
			{data.value.map((item) => (
				<StyledValue key={item.apiFieldItem}>
					- {item[data.field.variable.list_object_property]}
				</StyledValue>
			))}
		</StyledWrapperBox>
	)
}

SimpleApiFieldText.propTypes = {
	data: object,
}

export default SimpleApiFieldText
